import { render, staticRenderFns } from "./mobile-ad.vue?vue&type=template&id=3b295f02&scoped=true"
import script from "./mobile-ad.vue?vue&type=script&lang=js"
export * from "./mobile-ad.vue?vue&type=script&lang=js"
import style0 from "./mobile-ad.vue?vue&type=style&index=0&id=3b295f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b295f02",
  null
  
)

export default component.exports